import EventHelperCommon from "../scheduler-event-helper/common";

/**
 * 重なっているイベントを調整する
 * @param {EventModel} editedEvent
 * @param {*} targetEvents
 */
const adjustPushAsync = async (editedEvent, targetEvents) => {
  // 重なっているイベントを取得
  const overlappingEvents = targetEvents.filter(event => {
    return EventHelperCommon.isOverlapping(editedEvent, event);
  });

  for (const overlap of overlappingEvents) {
    // 左側が重なっている場合は終了日を更新
    if (EventHelperCommon.isOverlappingLeft(editedEvent, overlap)) {
      await overlap.setEndDate(editedEvent.startDate);
    }

    // 右側が重なっている場合は開始日を更新
    if (EventHelperCommon.isOverlappingRight(editedEvent, overlap)) {
      await overlap.setStartDate(editedEvent.endDate, false);
    }
  }
};

const adjustPullAsync = async (editedEvent, targetEvents) => {
  // 同じ乗船期間IDのイベントを取得
  let samePeriodEvents = targetEvents.filter(event => {
    return (
      event.enterprise_manning_vessel_crew_id ===
      editedEvent.enterprise_manning_vessel_crew_id
    );
  });
  if (samePeriodEvents.length === 0) {
    return;
  }

  // 包含チェック
  // 更新イベントが包含されている場合は終了
  for (const event of samePeriodEvents) {
    if (EventHelperCommon.isContained(editedEvent, event)) {
      return;
    }
  }

  samePeriodEvents.push(editedEvent);
  // 開始日でソート
  samePeriodEvents.sort(EventHelperCommon.sortByStartDate);
  const editedEventIndex = samePeriodEvents.findIndex(
    event => event.id === editedEvent.id
  );

  if (editedEventIndex !== 0) {
    const prevEvent = samePeriodEvents[editedEventIndex - 1];
    if (prevEvent.endDate !== editedEvent.startDate) {
      await prevEvent.setEndDate(editedEvent.startDate);
    }
  }

  if (editedEventIndex !== samePeriodEvents.length - 1) {
    const nextEvent = samePeriodEvents[editedEventIndex + 1];
    if (nextEvent.startDate !== editedEvent.endDate) {
      await nextEvent.setStartDate(editedEvent.endDate, false);
    }
  }
};

export { adjustPushAsync, adjustPullAsync };
